import React, { useEffect, useMemo, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { API } from "aws-amplify";
import * as mutations from "../graphql/mutations";
import PlacesAutocomplete from "react-places-autocomplete";
import { Helmet, HelmetProvider } from "react-helmet-async";

import img1 from "../assets/IMG_3020.JPG";
import img3 from "../assets/wc.png";


import "./home.css"; // keep your existing styles if helpful

const googleObj = typeof window !== "undefined" ? window.google : undefined;

const todayStr = (() => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
})();

/**
 * Lightweight, MDB-free rewrite of your ClassicFormPage.
 * - Pure HTML elements + minimal CSS classes
 * - Keeps PlacesAutocomplete, Amplify API, and your business logic
 * - Simple modal + stepper implemented without external UI libs
 */
export default function ClassicFormPage() {
  const [modal, setModal] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(false);

  const [formStep, setFormStep] = useState(1);
  const [formStepTouched, setFormStepTouched] = useState(false);

  const [optionsTrip] = useState([
    { text: "One way", value: "One way" },
    { text: "Roundtrip", value: "Roundtrip" },
  ]);
  const [optionsPatient] = useState([
    { text: "Wheelchair", value: "Wheelchair" },
    { text: "Ambulatory", value: "Ambulatory" },
  ]);

  const [notes, setNotes] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [repPhone] = useState("689-318-0337");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [duration, setDuration] = useState("");
  const [distance, setDistance] = useState(0);
  const [wheelchair, setWheelchair] = useState("");
  const [roundTrip, setRoundTrip] = useState("");
  const [status] = useState("new");
  const [price, setPrice] = useState(0);
  const [appointmentTime, setAppointmentTime] = useState("");
  const [appointmentDate, setAppointmentDate] = useState(todayStr);

  const [isNextDisabled, setIsNextDisabled] = useState(true);

  useEffect(() => {
    const nav = document.querySelector("nav");
    if (nav) nav.style.height = "65px";
    return () => {
      if (nav) nav.style.height = "auto";
    };
  }, []);

  useEffect(() => {
    // Enable/disable Next on step 1
    if (formStep === 1) {
      setIsNextDisabled(!(fname && lname && phone));
    }
  }, [fname, lname, phone, formStep]);

  const goToPrice = () => {
    document.getElementById("price")?.scrollIntoView({ behavior: "smooth" });
  };
  const goToBook = () => {
    document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
  };
  const goToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  const swapFormActive = (step) => () => {
    setFormStep(step);
    setFormStepTouched(true);
  };

  const handleNextPrevClick = (step) => () => {
    if (step === 5) {
      calcDistance();
    }
    setFormStep(step);
    setFormStepTouched(true);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const cleaned = ("" + value).replace(/\D/g, "");
    const m = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (m) {
      const intl = m[1] ? "+1 " : "";
      return [intl, "(", m[2], ") ", m[3], "-", m[4]].join("");
    }
    return value;
  };

  const calcPrice = () => {
    const isRoundTrip = roundTrip === "Roundtrip";
    const apptDate = new Date(appointmentDate);
    // time comes from separate input; combine for hour checks
    let apptDateTime = new Date(apptDate);
    if (appointmentTime) {
      const [hh, mm] = appointmentTime.split(":").map(Number);
      apptDateTime.setHours(hh || 0, mm || 0, 0, 0);
    }
    const hour = apptDateTime.getHours();
    const isEarlyOrLate = hour < 6 || hour >= 19;
    const isWeekend = [0, 6].includes(apptDateTime.getDay()) || isEarlyOrLate;
    const exceeds30Miles = distance > 30;
    const basePrice = distance * (exceeds30Miles || isWeekend || isEarlyOrLate ? 3 : 2);
    const p = isRoundTrip
      ? basePrice * 2 + (exceeds30Miles || isWeekend || isEarlyOrLate ? 120 : 80)
      : basePrice + (exceeds30Miles || isWeekend || isEarlyOrLate ? 60 : 40);
    setPrice(p);
    setModal(true);
  };

  const calcDistance = () => {
    if (!address || !address2) {
      alert("Please add a to and from destination.");
      return;
    }
    if (!googleObj?.maps?.DistanceMatrixService) {
      alert("Google Maps not loaded yet. Please try again in a moment.");
      return;
    }
    const service = new googleObj.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [address],
        destinations: [address2],
        travelMode: googleObj.maps.TravelMode.DRIVING,
        unitSystem: googleObj.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false,
      },
      (response, status) => {
        if (
          status === googleObj.maps.DistanceMatrixStatus.OK &&
          response.rows[0].elements[0].status !== "ZERO_RESULTS"
        ) {
          const kmText = response.rows[0].elements[0].distance.text; // e.g. "12.3 km"
          const km = parseFloat(kmText.replace(/[^0-9.]/g, ""));
          // convert to miles
          const miles = Math.round((km / 1.609) * 100) / 100;
          setDistance(miles);
          setDuration(response.rows[0].elements[0].duration.text);
          calcPrice();
        } else {
          alert("Unable to find the distance via road.");
        }
      }
    );
  };

  const newCustomer = async (e) => {
    e.preventDefault();
    const newCustomer = {
      fname,
      lname,
      phoneNumber: formatPhoneNumber(phone),
      emailAddress: email,
      address,
    };
    await API.graphql({ query: mutations.createCustomer, variables: { input: newCustomer } });
    alert("Customer Added!");
    window.location.reload();
  };

  const submitTrip = async (e) => {
    e.preventDefault();
    const newTrips = {
      fname,
      lname,
      address,
      address2,
      wheelchair,
      roundtrip: roundTrip,
      appointmentTime,
      appointmentDate: new Date(appointmentDate).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      }),
      status,
      phoneNumber: phone,
    };

    await API.graphql({ query: mutations.createTrip, variables: { input: newTrips } });
    sendText();
    sendText1();
    alert("Your request has been submitted!");
    window.location.href = "https://www.fivegtransportation.com/";
  };

  const sendText = () => {
    const dateStr = new Date(appointmentDate).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    fetch(
      `https://zhvzmdpj5b.execute-api.us-east-2.amazonaws.com/dev/items?recipient=${encodeURIComponent(
        phone
      )}&textmessage=${encodeURIComponent(
        `A rep will contact you to confirm availability shortly. Date: ${dateStr} Time: ${appointmentTime}`
      )}`
    ).catch((err) => console.error(err));
  };

  const sendText1 = () => {
    const dateStr = new Date(appointmentDate).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    const msg = `${dateStr} ${appointmentTime} ${fname} ${lname} ${address} ${address2} ${wheelchair} ${roundTrip} ${phone}`;
    fetch(
      `https://zhvzmdpj5b.execute-api.us-east-2.amazonaws.com/dev/items?recipient=9546619791&textmessage=${encodeURIComponent(
        msg
      )}`
    ).catch((err) => console.error(err));
  };

  const stepClass = (n) =>
    `step ${formStep === n ? "active" : formStep > n ? "done" : ""}`;

  return (
    <HelmetProvider>
      <div id="classicformpage">
        <Router>
 <nav className="navbar fixed-top shadow-sm" style={{ background: "#fff" }}>
  <div className="container navbar-inner">
    <div className="brand"><strong className="text-dark">Wheelchair Transport</strong></div>

    <button
      className="hamburger"
      onClick={() => setCollapseOpen(v => !v)}
      aria-label="Toggle menu"
      aria-expanded={collapseOpen}
      aria-controls="main-nav"
    >
      ☰
    </button>

    <ul id="main-nav" className={`navlinks ${collapseOpen ? "open" : ""}`}>
      <li><button className="link" onClick={goToPrice}>Home</button></li>
      <li><button className="link" onClick={goToPrice}>Our Prices</button></li>
      <li><button className="btn primary" onClick={() => setModal(true)}>Book Transportation</button></li>
      <li><button className="link" onClick={goToContact}>Contact Us</button></li>
    </ul>
  </div>
</nav>

        </Router>

        {/* HERO + INTRO */}
        <section id="view1" className="hero">
          <div className="container card p-lg" style={{ paddingTop: "8rem" }}>
            <div className="row center">
              <div className="col col-2 hide-sm" />
              <div className="col col-8 text-center">
                <a href="tel:+1-689-318-0337" className="black-text">
                  <h3 className="mb-2">🚑 Wheelchair Transportation</h3>
                  <div className="blockquote">689-318-0337</div>
                </a>
                <p className="mt-2">Our mission is to provide mobility assistance to the elderly, mobility impaired and wheelchair-bound residents with superb quality wheelchair transportation in North Florida with the highest care and lowest possible cost.</p>
                <p>Our wheelchair transportation division has the highest standard of safety and professionalism in the industry. Our vans are fully equipped, insured and all drivers are properly trained.</p>
                {/* <button className="btn outline danger" onClick={() => setModal(true)}>🚑 Schedule Online</button> */}
                <br /><br />
                <img src={img3} alt="wheelchair" className="img fluid shadow" />
              </div>
              <div className="col col-2 hide-sm" />
            </div>
          </div>

          {/* CONTACT/ABOUT LEFT + IMAGE RIGHT */}
          <div id="contact" className="container mt-6">
            <div className="row">
              <div className="col col-6">
                <h1 className="text-dark text-center">Non-Emergency Medical Transportation Service</h1>
                <a href="tel:+1-689-318-0337"><h3 className="text-center">(689) 318-0337</h3></a>
                <hr />
                <h4 className="text-center">
                  Medical Transportation<br />
                  Dialysis Transportation<br />
                  Transportation for Seniors<br />
                  Transportation for Worship Service<br />
                  <br />
                  Servicing Hospitals, Nursing Homes, Residential and more.<br />
                  Professional, Safe and Reliable Service<br />
                  <br />
                  Servicing Gainesville Florida<br />

                </h4>
                <div className="text-center mt-2">
                  {/* <button className="btn outline danger" onClick={() => setModal(true)}>Schedule Transportation 🚑</button> */}
                </div>
              </div>
              <div className="col col-6">
                <img className="img fluid" src={img1} alt="wheelchair-lift" />
              </div>
            </div>
          </div>
        </section>

        {/* PRICING */}
        <section id="price" className="container mt-6">
          <h2 className="text-center">Transportation Prices</h2>
          <p className="text-center muted">The rates listed below are based on a one-way trip. (Round trip will be the load fee x2 plus the mileage rate times the round-trip mileage.)</p>
          <div className="row gap">
            <div className="col col-4">
              <div className="card p-md h-100">
                <h5 className="mb-2">AMBULATORY TRANSPORTATION</h5>
                <div className="circle">🚗</div>
                <h2 className="my-2">Load Fee</h2>
                <p className="muted">Plus $Per Mile</p>
                {/* <button className="btn" onClick={() => setModal(true)}>Schedule Now</button> */}
              </div>
            </div>
            <div className="col col-4">
              <div className="card gradient p-md h-100 white-text">
                <h5 className="mb-2">WHEELCHAIR TRANSPORTATION</h5>
                <div className="circle">🚚</div>
                <h2 className="my-2">$Load Fee</h2>
                <p>Plus $Per Mile</p>
                {/* <button className="btn outline light" onClick={() => setModal(true)}>Schedule Now</button> */}
              </div>
            </div>
            <div className="col col-4">
              <div className="card p-md h-100">
                <h5 className="mb-2">AFTER HOUR TRAVEL/DISTANCE 30+ MILES</h5>
                <div className="circle">🚐</div>
                <h2 className="my-2">$Load Fee</h2>
                <p className="muted">Plus $Per Mile</p>
                {/* <button className="btn" onClick={() => setModal(true)}>Schedule Today</button> */}
              </div>
            </div>
          </div>
        </section>



        {/* REVIEWS (static cards replacing carousel/testimonials) */}


        {/* FOOTER */}
        <footer id="footer" className="footer mt-6">
          <div className="container text-center">
            <div>© {new Date().getFullYear()} FIVE G TRANSPORTATION</div>
            <div><a href="tel:+1-689-318-0337" className="text-danger">(689)318-0337</a></div>
          </div>
        </footer>

        {/* MODAL (simple, no external libs) */}
        {modal && (
          <div className="modal-backdrop" role="dialog" aria-modal="true">
            <div className="modal">
              <div className="modal-header">
                <h3>Request Transportation</h3>
                <button className="icon-btn" onClick={() => setModal(false)} aria-label="Close">×</button>
              </div>

              {/* Stepper */}
              <div className="stepper">
                <button className={stepClass(1)} onClick={swapFormActive(1)}>1</button>
                <button className={stepClass(2)} onClick={swapFormActive(2)}>2</button>
                <button className={stepClass(3)} onClick={swapFormActive(3)}>3</button>
                <button className={stepClass(4)} onClick={swapFormActive(4)}>4</button>
                <button className={stepClass(5)} onClick={swapFormActive(5)}>5</button>
              </div>

              <div className="modal-body">
                {formStep === 1 && (
                  <div>
                    <h4 className="text-center">Customer Information</h4>
                    <form className="grid gap" onSubmit={newCustomer}>
                      <label>
                        First Name
                        <input type="text" value={fname} onChange={(e) => setFname(e.target.value)} required autoFocus={formStepTouched} />
                      </label>
                      <label>
                        Last Name
                        <input type="text" value={lname} onChange={(e) => setLname(e.target.value)} required />
                      </label>
                      <label>
                        Cell Phone Number
                        <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                      </label>
                      <div className="flex between mt-2">
                        <button type="button" className="btn secondary" onClick={() => setModal(false)}>Cancel</button>
                        <button type="button" className="btn primary" disabled={isNextDisabled} onClick={handleNextPrevClick(2)}>Next</button>
                      </div>
                    </form>
                  </div>
                )}

                {formStep === 2 && (
                  <div>
                    <h4 className="text-center">Pickup Address</h4>
                    <PlacesAutocomplete value={address} onChange={setAddress}>
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <input {...getInputProps({ placeholder: "Pickup Address...", className: "input" })} />
                          <div className="autocomplete">
                            {loading && <div>Loading...</div>}
                            {suggestions.map((s, idx) => (
                              <div key={idx} {...getSuggestionItemProps(s, { className: `suggestion ${s.active ? "active" : ""}` })}>{s.description}</div>
                            ))}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                    <div className="flex between mt-2">
                      <button className="btn secondary" onClick={handleNextPrevClick(1)}>Previous</button>
                      <button className="btn primary" onClick={handleNextPrevClick(3)}>Next</button>
                    </div>
                  </div>
                )}

                {formStep === 3 && (
                  <div>
                    <h4 className="text-center">Destination Address</h4>
                    <PlacesAutocomplete value={address2} onChange={setAddress2}>
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <input {...getInputProps({ placeholder: "Destination Address...", className: "input" })} />
                          <div className="autocomplete">
                            {loading && <div>Loading...</div>}
                            {suggestions.map((s, idx) => (
                              <div key={idx} {...getSuggestionItemProps(s, { className: `suggestion ${s.active ? "active" : ""}` })}>{s.description}</div>
                            ))}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                    <div className="flex between mt-2">
                      <button className="btn secondary" onClick={handleNextPrevClick(2)}>Previous</button>
                      <button className="btn primary" onClick={handleNextPrevClick(4)}>Next</button>
                    </div>
                  </div>
                )}

                {formStep === 4 && (
                  <div>
                    <h4 className="text-center">Trip Details</h4>
                    <div className="grid gap">
                      <label>
                        Appointment Date
                        <input type="date" value={useMemo(() => {
                          // Convert mm/dd/yyyy to yyyy-mm-dd for input[type=date]
                          const [mm, dd, yyyy] = appointmentDate.split("/");
                          return `${yyyy}-${mm}-${dd}`;
                        }, [appointmentDate])}
                          onChange={(e) => {
                            const [y, m, d] = e.target.value.split("-");
                            setAppointmentDate(`${m}/${d}/${y}`);
                          }} />
                      </label>

                      <label>
                        Trip type
                        <select value={roundTrip} onChange={(e) => setRoundTrip(e.target.value)}>
                          <option value="">Choose trip type</option>
                          {optionsTrip.map((o) => (
                            <option key={o.value} value={o.value}>{o.text}</option>
                          ))}
                        </select>
                      </label>

                      <label>
                        Patient Type
                        <select value={wheelchair} onChange={(e) => setWheelchair(e.target.value)}>
                          <option value="">Choose patient type</option>
                          {optionsPatient.map((o) => (
                            <option key={o.value} value={o.value}>{o.text}</option>
                          ))}
                        </select>
                      </label>

                      <label>
                        Appointment Time
                        <input type="time" value={appointmentTime} onChange={(e) => setAppointmentTime(e.target.value)} />
                      </label>
                    </div>
                    <div className="flex between mt-2">
                      <button className="btn secondary" onClick={handleNextPrevClick(3)}>Previous</button>
                      <button className="btn primary" onClick={handleNextPrevClick(5)}>Next</button>
                    </div>
                  </div>
                )}

                {formStep === 5 && (
                  <div>
                    <h4 className="text-center">Trip Summary</h4>
                    <div className="text-center">
                      <h4 className="my-1">Est Time: <span className="text-danger">{duration}</span></h4>
                      <h4 className="my-1">Est Miles: <span className="text-danger">{roundTrip === "Roundtrip" ? distance * 2 : distance}</span></h4>
                      <h4 className="my-1">Est Cost: <span className="text-danger">${Math.round(price * 100) / 100}</span></h4>
                      <button className="btn danger" onClick={calcDistance}>Calculate Price</button>
                    </div>

                    <div className="table-wrap mt-3">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Phone</th>
                            <th>Pickup Address</th>
                            <th>Destination Address</th>
                            <th>Appointment Time</th>
                            <th>Appointment Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{fname}</td>
                            <td>{lname}</td>
                            <td>{phone}</td>
                            <td>{address}</td>
                            <td>{address2}</td>
                            <td>{appointmentTime}</td>
                            <td>{new Date(appointmentDate).toLocaleString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="flex between mt-2">
                      <button className="btn secondary" onClick={handleNextPrevClick(4)}>Previous</button>
                      <button className="btn primary" onClick={submitTrip}>Submit Request</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Minimal CSS (scoped-ish) - you can move this into home.css */}
      <Helmet>
        <style>{`
          .container{max-width:1100px;margin:0 auto;padding:0 1rem}
          .row{display:flex;flex-wrap:wrap}
          .center{align-items:center}
          .gap{gap:1rem}
          .col{padding:0.5rem}
          .col-2{flex:0 0 16.666%}
          .col-4{flex:0 0 33.333%}
          .col-6{flex:0 0 50%}
          .col-8{flex:0 0 66.666%}
          .text-center{text-align:center}
          .text-danger{color:#c62828}
          .muted{color:#555}
          .mt-2{margin-top:0.75rem}
          .mt-3{margin-top:1rem}
          .mt-6{margin-top:3rem}
          .mb-2{margin-bottom:0.75rem}
          .mb-1{margin-bottom:0.5rem}
          .my-1{margin:0.5rem 0}
          .my-2{margin:1rem 0}
          .p-md{padding:1rem}
          .p-lg{padding:2rem}
          .card{background:#fff;border-radius:12px;box-shadow:0 6px 20px rgba(0,0,0,.07)}
          .shadow{box-shadow:0 6px 20px rgba(0,0,0,.12)}
          .hero{background:linear-gradient(180deg,#f7f7f7,transparent)}
          .img.fluid{max-width:100%;height:auto}
          .avatar{width:72px;height:72px;border-radius:50%;object-fit:cover;margin:0 auto}
          .circle{width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#f2f2f2;margin:0 auto}
          .gradient{background:linear-gradient(45deg,#ff6b6b,#ffe66d);}
          .white-text{color:#fff}
          .navbar{position:sticky;top:0;z-index:50}
          .navbar .container{display:flex;align-items:center;justify-content:space-between;padding:0.5rem 1rem}
          .hamburger{background:none;border:none;font-size:1.25rem}
          .navlinks{display:flex;gap:1rem}
          .navlinks.open{display:flex}
          .link{background:none;border:none;color:#333;cursor:pointer}
          .btn{display:inline-block;border:none;background:#1976d2;color:#fff;padding:0.6rem 1rem;border-radius:999px;cursor:pointer}
          .btn.primary{background:#1976d2}
          .btn.secondary{background:#9e9e9e}
          .btn.danger{background:#d32f2f}
          .btn.outline{background:transparent;border:2px solid #1976d2;color:#1976d2}
          .btn.outline.danger{border-color:#d32f2f;color:#d32f2f}
          .btn.outline.light{border-color:#fff;color:#fff}
          .footer{background:#f7f7f7;padding:2rem 0}
          .text-dark{color:#111}
          .blockquote{font-weight:bold}
          .table-wrap{overflow:auto}
          table{width:100%;border-collapse:collapse}
          th,td{padding:0.5rem;border-bottom:1px solid #eee;text-align:left}

          /* Modal */
          .modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;padding:1rem}
          .modal{background:#fff;border-radius:16px;max-width:900px;width:100%;max-height:85vh;overflow:auto;box-shadow:0 16px 48px rgba(0,0,0,.2)}
          .modal-header{display:flex;align-items:center;justify-content:space-between;padding:1rem 1.25rem;border-bottom:1px solid #eee}
          .modal-body{padding:1rem 1.25rem}
          .icon-btn{background:transparent;border:none;font-size:1.5rem;cursor:pointer}

          /* Stepper */
          .stepper{display:flex;gap:0.5rem;justify-content:center;padding:0.75rem}
          .step{width:34px;height:34px;border-radius:50%;border:2px solid #ccc;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer}
          .step.active{border-color:#1976d2;background:#1976d2;color:#fff}
          .step.done{border-color:#4caf50;background:#4caf50;color:#fff}

          /* Inputs */
          .grid{display:grid}
          .grid.gap{gap:0.75rem}
          label{display:grid;gap:0.25rem;font-size:0.95rem}
          input, select, textarea{padding:0.6rem;border:1px solid #ddd;border-radius:10px;outline:none}
          input:focus, select:focus, textarea:focus{border-color:#1976d2;box-shadow:0 0 0 3px rgba(25,118,210,.12)}

          /* Autocomplete */
          .autocomplete{border:1px solid #eee;border-radius:10px;margin-top:0.25rem;max-height:220px;overflow:auto}
          .suggestion{padding:0.5rem}
          .suggestion.active{background:#f5f9ff}

          /* Responsive */
          @media (max-width: 768px){
            .col-2,.col-4,.col-6,.col-8{flex:0 0 100%}
            .navlinks{display:none;flex-direction:column;align-items:flex-end}
            .navlinks.open{display:flex}
            .hide-sm{display:none}
          }
        `}</style>
      </Helmet>
    </HelmetProvider>
  );
}
